<app-header
  text="Standorte aktivieren"
  icon="fas fa-map-location-dot"></app-header>

@if (activeUserStore.canUseAccessibility()) {
  <p-accordion styleClass="mb-3">
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="flex align-items-center justify-content-between w-full">
          <div class="flex align-items-center gap-2">
            <i class="fas fa-person-walking-arrow-right"></i>
            <span>Erreichbarkeit</span>
          </div>
          <div class="flex align-items-center gap-2 mr-2">
            <span class="text-xs text-secondary">
              {{ getIsochroneProfileLabel() }} |
              {{ getIsochroneMinutesSummary() }}
            </span>
          </div>
        </div>
      </ng-template>

      <div class="flex flex-column gap-2">
        <div class="grid">
          <app-form-field-wrapper [label]="'Reiseart'" [colSize]="12">
            <p-dropdown
              [(ngModel)]="isochroneProfile"
              [options]="isochroneProfileOptions">
              <ng-template pTemplate="selectedItem" let-item>
                <div class="flex align-items-center gap-2">
                  <i [class]="item.icon"></i>
                  <span>{{ item.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-item>
                <div class="flex align-items-center gap-2">
                  <i [class]="item.icon"></i>
                  <span>{{ item.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </app-form-field-wrapper>
        </div>
        <div class="grid mt-2">
          <app-form-field-wrapper [label]="'Intervalle (Minuten)'" [colSize]="12">
            <p-chips
              [(ngModel)]="isochroneMinutes"
              [addOnBlur]="true"
              [separator]="','"></p-chips>
          </app-form-field-wrapper>
        </div>
        <div class="grid mt-2">
          <app-colorset-dropdown
            label="Farben für Zeitintervalle"
            [enableNewOption]="true"
            [(ngModel)]="isochroneColorset"></app-colorset-dropdown>
        </div>

        @if (isochroneColorset) {
          <div class="flex flex-wrap gap-2 mt-2">
            @for (minute of isochroneMinutes; track minute; let i = $index) {
              <div class="flex align-items-center gap-1 text-xs">
                <div
                  [style.background-color]="getIsochroneColor(i)"
                  class="w-1rem h-1rem border-round shadow-1"></div>
                <span>{{ minute }} Min.</span>
              </div>
            }
          </div>
        }
      </div>
    </p-accordionTab>
  </p-accordion>

  <p-divider styleClass="my-3" />
}

<app-search-input
  (search)="search($event)"
  placeholder="Standorte durchsuchen ..."></app-search-input>
@if (typeSelectItems && typeSelectItems.length > 0) {
  <div class="flex flex-column gap-2 mt-3">
    @for (poi of typeSelectItems; track poi._id) {
      <app-poi-type-item
        [poi]="poi"
        [expanded]="isExpanded(poi._id)"
        (toggleExpanded)="toggleCategory(poi._id)">
        <p-checkbox
          poi-left
          (click)="$event.stopPropagation()"
          [value]="poi._id"
          [(ngModel)]="selectedPoiIds"
          (ngModelChange)="onSelectionChange()"
          [inputId]="poi._id">
        </p-checkbox>

        <app-poi-list
          poi-content
          [activeKey]="openPoiKey"
          (poiClicked)="callPoiClickEvent($event, poi._id)"
          [searchWord]="searchWord"
          [dataLayer]="layerStore.getLatestByParent(poi._id)" />
      </app-poi-type-item>
    }
  </div>
}
